export default "__VITE_ASSET__CkCdND6P__"